const Theme = {
  logo_image_url: 'meet4impact.png',
  logo_height: 100,

  button_color: '#007689',
  button_half_border_color: '#007689',

  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,
}

export default Theme
